/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ListedAnniversary = {
    properties: {
        month: {
    type: 'number',
},
        employees: {
    type: 'array',
    contains: {
        type: 'AnniversaryEmployeeInfo',
    },
    isRequired: true,
},
    },
};